<template>
  <!-- TODO should also be based on returning user -->
  <div id="app" ref="app" class="container" :class="{'expand': checkout.currentStep == 1}">
    <template v-if="checkout.currentStep == 0">
      <cart-summary @checkoutStep="showNext()" :items="itemsWithoutDiscounts" :checkout="checkout" v-if="itemsWithoutDiscounts" ></cart-summary>
    </template>

      <template v-if="checkout.currentStep == 1">
        <order-summary :checkout="checkout"></order-summary>
        <checkout-info :checkout="checkout"></checkout-info>
      </template>

    <transition name="thank-you" appear appear-active-class="showThankyou">
      <thank-you-section v-if="checkout.currentStep == 2">
      </thank-you-section>
    </transition>

  </div>
</template>

<script>
  import CbInitializer from "./services/cb-initializer.js";
  import CartSummary from "./components/CartSummary.vue";
  import CheckoutStepOrderSummary from "./components/CheckoutStepOrderSummary.vue";
  import CheckoutInfo from "./components/CheckoutInfo.vue";
  import ThankYouPage from "./components/ThankYouPage.vue";

  export default {
    name: 'app',
    data () {
      return {
        fields: [],
        value: {},
        checkout: {
        }
      }
    },
    components: {
      'cart-summary': CartSummary,
      'order-summary': CheckoutStepOrderSummary,
      'checkout-info': CheckoutInfo,
      'thank-you-section': ThankYouPage
    },
    created() {
      this.checkout = CbInitializer.init();
    },
    methods: {
      showNext() {
        this.checkout.currentStep = 1;
      }
    },
    computed: {
      itemsWithoutDiscounts() {
        return this.checkout.lineItems.filter(l => l.type == "plan" || l.type == "addon");
      }
    }
  }
</script>
<style type="text/css" scoped>
  .container.expand {
    height: auto;
  }

  .info-leave, .info-leave-active{
    animation-name: disappearContent;
    animation-duration: .5s;
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    animation-fill-mode: forwards;
  }
</style>


// WEBPACK FOOTER //
// App.vue?b183be14